import React from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import { ApolloProvider } from "@apollo/client";

import { SmsWallProvider } from "apps/messenger/hooks/useSmsWall";
import { ModalProvider } from "shared/hooks/useModal";
import getApolloClient from "shared/util/getApolloClient";

const Providers = ({ children, store }) => (
	<Provider store={store}>
		<ApolloProvider client={getApolloClient()}>
			<SmsWallProvider>
				<ModalProvider>
					{children}
				</ModalProvider>
			</SmsWallProvider>
		</ApolloProvider>
	</Provider>
);

Providers.propTypes = {
	children: PropTypes.node.isRequired,
	store: PropTypes.object.isRequired,
};

export default Providers;



// WEBPACK FOOTER //
// ./src/routers/shared/components/Providers.jsx